module.exports = __webpack_public_path__ + "img/7.75748ac8.jpg";